import { render } from "./FacilityServicesDashboard.vue?vue&type=template&id=57f5b5e8&scoped=true"
import script from "./FacilityServicesDashboard.vue?vue&type=script&lang=js"
export * from "./FacilityServicesDashboard.vue?vue&type=script&lang=js"

import "./FacilityServicesDashboard.vue?vue&type=style&index=0&id=57f5b5e8&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f5b5e8"]])

export default __exports__